export enum SectionColumnConfigCollectiveTerpeneKey {
  TopTerpene = 'TopTerpene',
  TotalTerpene = 'TotalTerpene',
  ListTerpenes = 'ListTerpenes'
}
